// src/pages/auth/index.jsx
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import LoginPage from "../../components/static/auth/LoginPage";
import RegisterPage from "../../components/static/auth/RegisterPage";

const AuthPages = () => {
  const location = useLocation();
  const [isLoginPage, setIsLoginPage] = useState(true);

  // Check if we should show the register form based on navigation state or path
  useEffect(() => {
    if (location.pathname === "/signup" || location.state?.showRegister === true) {
      setIsLoginPage(false);
    } else if (location.state?.showRegister === false) {
      setIsLoginPage(true);
    }
  }, [location.pathname, location.state]);

  const switchToRegister = (e) => {
    // e.preventDefault(); // Prevent default link behavior
    setIsLoginPage(false);
  };

  const switchToLogin = (e) => {
    // e.preventDefault(); // Prevent default link behavior
    setIsLoginPage(true);
  };

  return (
    <div>
      {isLoginPage ? (
        <LoginPage onSwitchToRegister={switchToRegister} />
      ) : (
        <RegisterPage onSwitchToLogin={switchToLogin} />
      )}
    </div>
  );
};

export default AuthPages;
